<template>
  <v-container>
    <v-card elevation="1">
      <v-card-title class="primary darken-1 white--text font-weight-bold justify-center">
        <v-icon class="mr-2" color="white">mdi-database-import-outline</v-icon>
        import Data
      </v-card-title>
      <v-card-title v-if="getPreview" class="pa-8">
        <v-layout row wrap>
          <h4>Preview of your data to be imported</h4>
          <v-row class="pr-12 pt-2" justify="end">
            <v-btn
                class="mr-2"
                color="warning"
                @click="cancel"
            >
              <v-icon left>mdi-close-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn color="primary" @click="save">
              <v-icon left>mdi-content-save-check-outline</v-icon>
              Save
            </v-btn>
          </v-row>
        </v-layout>
      </v-card-title>
      <v-card-title v-if="!getPreview" class="pa-8">
        <v-layout justify-space-around row wrap>
          <v-card elevation="0" width="50%">
            <v-card-text v-if="!loading" :disabled="loading">
              <input
                  ref="json-upload-input"
                  accept=".json"
                  class="json-upload-input"
                  type="file"
                  @change="handleClick"
              />
              <div class="drop" @dragenter="handleDragover" @dragover="handleDragover" @drop="handleDrop">
                Drop JSON file here or
              </div>
            </v-card-text>
            <v-card-text v-if="!hasError&&loading" :disabled="loading" align="center">
              <!--              <v-progress-circular-->
              <!--                  v-if="loading"-->
              <!--                  :rotate="360"-->
              <!--                  :size="120"-->
              <!--                  :width="15"-->
              <!--                  class="mb-8"-->
              <!--                  color="primary"-->
              <!--                  indeterminate-->
              <!--              >-->
              <!--                wait...-->
              <!--              </v-progress-circular>-->
              <v-col class="my-12" cols="6">
                <v-progress-linear
                    color="primary"
                    height="6"
                    indeterminate
                    rounded
                ></v-progress-linear>
              </v-col>
              <h1 v-if="progress">Done Processing</h1>
              <h1 v-else>Processing uploaded data...</h1>
            </v-card-text>
            <v-card-text v-if="hasError" :disabled="loading">
              <v-col style="text-align-last: center">
                <v-icon class="mb-8 icon">mdi-alert-circle</v-icon>
                <h2 class="mb-4 text-center">{{ message }}</h2>
              </v-col>
              <ul class="ml-12" style="list-style-type: none">
                <li v-for="(item,index) in error" :key="index">
                  <h3 class="mb-2">
                    <v-icon class="mr-2">mdi-alert-circle</v-icon>
                    Row {{ item.index }}
                  </h3>
                  <ul v-for="(message,index) in item.errors" :key="index">
                    <li style="list-style-type: none"><h4>{{ message }}</h4></li>
                  </ul>
                </li>
              </ul>
            </v-card-text>
          </v-card>
          <v-btn v-if="!loading"
                 color="primary"
                 type="button"
                 @click="handleUpload"
          >
            <v-icon class="pr-2" dark>
              mdi-code-json
            </v-icon>
            Browse JSON File to import
          </v-btn>
        </v-layout>
        <v-card-text>
          <v-card-title class="grey--text font-weight-bold justify-center">
            <v-icon class="mr-2" color="grey">mdi-eye</v-icon>
            Preview Will Be Here
          </v-card-title>
        </v-card-text>
      </v-card-title>
      <v-divider class="my-2"></v-divider>
      <v-snackbar
          v-model="snackbar"
          ccolor="primary"
          text
      >
        {{ message }}

        <template v-slot:action="{ attrs }">
          <v-btn
              color="pink"
              text
              v-bind="attrs"
              @click="snackbar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <v-card-subtitle v-if="error_message" class="white--text error"
      >{{ error_message }}
      </v-card-subtitle>
      <v-card-text v-if="getPreview">
        <v-tabs
            v-model="tab"
            background-color="primary darken-3"
            dark
            grow
        >
          <v-tab
              v-for="item in items"
              :key="item"
              class="font-weight-bold"
          >
            {{ item }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item
              v-for="(item,index) in items"
              :key="item"
          >
            <v-card
                color="basil"
                flat
            >
              <v-card-text>
                <v-data-table
                    v-model="selected[index].data"
                    :footer-props="{ 'items-per-page-options': itemsPerPage }"
                    :headers="getHeaders(item)"
                    :items="getItems(item)"
                    :items-per-page="-1"
                    :options.sync="options"
                    class="elevation-1 mt-3"
                    item-key="id"
                    show-select
                    style="cursor: pointer"
                ></v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>

import axios from "axios";

export default {
  props: {
    beforeUpload: Function, // eslint-disable-line
    onSuccess: Function, // eslint-disable-line
  },
  data() {
    return {
      tab: null,
      items: [
        'Persons', 'Position', 'Performance Evaluation',"DepartmentORCaseteam", "Job Position Stock"
      ],
      personsHeader: [],
      personsData: [],
      positionHeader: [],
      positionData: [],
      performanceHeader: [],
      performanceData: [],
      departmentHeader: [],
      departmentData: [],
      jobPositionHeader: [],
      jobPositionData: [],
      selected: [
        {
          name: "Persons",
          headers: [],
          data: []
        },
        {
          name: "Position",
          headers: [],
          data: []
        },
        {
          name: "Performance Evaluation",
          headers: [],
          data: []
        },
        {
          name: "DepartmentORCaseteam",
          headers: [],
          data: []
        },
        {
          name: "Job Position Stock",
          headers: [],
          data: []
        },
      ],
      options: {itemsPerPage: 10},
      hasError: false,
      getPreview: false,
      message: "",
      error: [],
      snackbar: false,
      loading: false,
      progress: false,
      importedData: null
    };
  },
  methods: {
    handleDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      if (this.loading) return;
      const files = e.dataTransfer.files;
      if (files.length !== 1) {
        this.message = "Only support uploading one file!";
        this.snackbar = true;
        return;
      }
      const rawFile = files[0]; // only use files[0]
      if (!this.isJSON(rawFile)) {
        this.message = "only support uploading JSON file!";
        this.snackbar = true;
        return false;
      }
      this.upload(rawFile);
      e.stopPropagation();
      e.preventDefault();
    },
    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },
    handleUpload() {
      this.$refs["json-upload-input"].click();
    },
    handleClick(e) {
      const files = e.target.files;
      const rawFile = files[0]; // only use files[0]
      if (!rawFile) return;
      if (!this.isJSON(rawFile)) {
        this.message = "only support uploading JSON file!";
        this.snackbar = true;
        return false;
      }

      this.upload(rawFile);
    },
    upload(rawFile) {
      this.$refs["json-upload-input"].value = null; // fix can't select the same excel
      if (!this.beforeUpload) {
        this.parseData(rawFile);
        return;
      }
      const before = this.beforeUpload(rawFile);
      if (before) {
        this.parseData(rawFile);
      }
    },
    parseData(rawFile) {
      this.loading = true;
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          this.progress = false
          let body = JSON.parse(new TextDecoder().decode(data))
          this.importedData = body;
          axios.post(`/es/getPreview`, body).then(({data}) => {
            this.getPreview = true;
            this.personsHeader = data.previewData.practitioner.headers;
            this.personsData = data.previewData.practitioner.data;
            this.positionHeader = data.previewData.practitionerRole.headers;
            this.positionData = data.previewData.practitionerRole.data;
            this.performanceHeader = data.previewData.PerformanceEvaluation.headers;
            this.performanceData = data.previewData.PerformanceEvaluation.data;
            this.departmentHeader = data.previewData.department.headers
            this.departmentData = data.previewData.department.data
            this.jobPositionHeader = data.previewData.jobPositionStock.headers
            this.jobPositionData = data.previewData.jobPositionStock.data
          }).catch(e => console.log(e))
          resolve();
        };
        reader.readAsArrayBuffer(rawFile);
      });
    },
    isJSON(file) {
      return /\.(json)$/.test(file.name);
    },
    getHeaders(item) {
      if (item === "Persons") {
        this.selected[0].headers = this.personsHeader
        return this.personsHeader
      }
      if (item === "Position") {
        this.selected[1].headers = this.positionHeader
        return this.positionHeader
      }
      if (item === "Performance Evaluation") {
        this.selected[2].headers = this.performanceHeader
        return this.performanceHeader
      }
      if(item === "DepartmentORCaseteam"){
        this.selected[3].headers = this.departmentHeader
        return this.departmentHeader
      }
      if(item === "Job Position Stock"){
        this.selected[4].headers = this.jobPositionHeader
        return this.jobPositionHeader
      }
    },
    getItems(item) {
      if (item === "Persons") {
        return this.personsData
      }
      if (item === "Position") {
        return this.positionData
      }
      if (item === "Performance Evaluation") {
        return this.performanceData
      }
      if(item === "DepartmentORCaseteam"){
        return this.departmentData
      }
      if(item === "Job Position Stock"){
        return this.jobPositionData
      }
    },
    getDataToSave() {
      let data = []
      let returnAll = true;
      for (let a of this.selected) {
        if (a.data.length > 0) {
          returnAll = false;
        }
      }

      if (returnAll) {
        data = [
          {
            name: "Persons",
            headers: this.personsHeader,
            data: this.personsData
          },
          {
            name: "Position",
            headers: this.positionHeader,
            data: this.positionData
          },
          {
            name: "Performance Evaluation",
            headers: this.performanceHeader,
            data: this.performanceData
          },
          {
            name: "DepartmentORCaseteam",
            headers: this.departmentHeader,
            data: this.departmentData
          },
          {
            name: "Job Position Stock",
            headers: this.jobPositionHeader,
            data: this.jobPositionData
          },
        ]
      } else {
        data = this.selected
      }

      return data;
    },
    filterData(input) {
      let data = this.getDataToSave()
      let practitionerData = [];
      let positionData = [];
      let performanceData = [];
      let departmentData = []
      let jobPositionStockData = []
      for (let entry of data) {
        if (entry.name === "Persons") {
          for (let person of entry.data) {
            practitionerData.push(person.id);
          }
        }
        if (entry.name === "Position") {
          for (let position of entry.data) {
            positionData.push(position.id);
          }
        }
        if (entry.name === "Performance Evaluation") {
          for (let performance of entry.data) {
            performanceData.push(performance.id);
          }
        }
        if (entry.name === "DepartmentORCaseteam") {
          for (let department of entry.data) {
            departmentData.push(department.id);
          }
        }
        if (entry.name === "Job Position Stock") {
          for (let jobPositionStock of entry.data) {
            jobPositionStockData.push(jobPositionStock.id);
          }
        }
      }
      let result = [];
      for (const entry of input) {
        if (entry.data && entry.data.length > 0) {
          let internalData = [];
          for (let data of entry.data) {
            if (data.role) {
              if (positionData.includes(data.role.id)) {
                internalData.push(data);
              }
            }
            if (data.resourceType === "Basic") {
              if (performanceData.includes(data.id)) {
                internalData.push(data);
              }
            }
          }

          if (internalData.length > 0) {
            entry.data = internalData;
            result.push(entry);
          }
        } else {
          if (!entry.data &&entry.practitioner && practitionerData.includes(entry.practitioner.id)) {
            result.push(entry);
          }
          if (!entry.data &&entry.department ) {
            let department = []
            for (const dept of entry.department) {
              if(departmentData.includes(dept.id)){
                department.push(dept);
              }
            }
            if(department.length>0){
              result.push({department})
            }
          }
          if (!entry.data &&entry.jobPositionStock ) {
            let jobPositionStock = []
            for (const stock of entry.jobPositionStock) {
              if(jobPositionStockData.includes(stock.id)){
                jobPositionStock.push(stock);
              }
            }
            if(jobPositionStock.length>0){
              result.push({jobPositionStock})
            }
          }
        }
      }
      return result;
    },
    cancel() {
      this.$router.go()
    },
    save() {
      let data = this.filterData(this.importedData)
      axios.post(`/utils/importData`, data).then((response) => {
        if (response.status === 201) {
          this.message = "Data Imported Successfully!"
          this.snackbar = true
            this.$router.go()
        }else {
          this.message = "There is some issue on data!"
          this.snackbar = true
        }
      }).catch(e => console.log(e))
    }
  }
};
</script>

<style scoped>
.json-upload-input {
  display: none;
  z-index: -9999;
}

.icon {
  font-size: 64px;
  color: red;
}

.drop {
  border: 2px dashed #bbb;
  width: 100%;
  height: 120px;
  line-height: 120px;
  margin: 0 auto;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;
}
</style>